import styled, { css } from 'styled-components'
import { rem } from 'utils/common'

export const ScrollButtonStyle = styled.button`
	background-color: ${({ theme }) => theme.color.secondary};
	border: 1px solid ${({ theme }) => theme.color.primary};
	display: none;
	cursor: pointer;
	position: fixed;
	padding-top: ${rem(2)};
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	align-self: flex-end;
	z-index: 2;
	bottom: ${rem(96)};
	right: ${rem(10)};
	width: ${rem(40)};
	height: ${rem(40)};
	transition: all 0.3s;
	opacity: 0.8;
	&:hover {
		opacity: 1;
	}
	&.active,
	&:active {
		opacity: 1;
		box-shadow: 3px 0 5px rgba(0, 0, 0, 0.25) inset;
	}

	svg {
		fill: ${({ theme }) => theme.color.primary};
	}

	${(p) =>
		p.visibility === 'show' &&
		css`
			display: flex;
		`}
`
